<template>
    <div>
        <h1 class="font-weight-light" :class="titleClass">Chords Grid Editor</h1>

        <h2 class="font-weight-light mt-2" :class="subtitleClass">{{ $t('subtitle-home') }}</h2>

        <v-container grid-list-sm class="my-3">
            <v-layout row wrap>
                <v-flex d-flex xs12>
                    <v-layout column>
                        <v-flex>
                            <v-card flat>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex class="xs12 sm7 lg8 text-xs-left order-xs1 order-sm1">
                                            <p class="title font-weight-regular">
                                                {{ $t('description-title-home') }}
                                            </p>
                                            <div>
                                                <div class="mb-2">{{ $t('you-can-home') }}</div>
                                                
                                                <ul>
                                                    <li>{{ $t('create-edit-grids-home') }}</li>
                                                    <li>{{ $t('print-song-home') }}</li>
                                                    <li>{{ $t('song-information-home') }}</li>
                                                    <li>{{ $t('colorize-measure-home') }}</li>
                                                    <li>{{ $t('use-repeats-home') }}</li>
                                                    <li>{{ $t('display-measures-number-home') }}</li>
                                                </ul>
                                            </div>
                                            <div class="subheading mt-5" v-if="!isMobile">
                                                {{ $t('you-can-create-your-song-home') }}
                                                <div class="text-xs-center">
                                                    <v-btn large class="text-xs-center mt-4" color="success" @click="$router.push('/new-song')">
                                                        <v-icon>music_note</v-icon>
                                                        {{ $t('create-your-song') }}
                                                    </v-btn>
                                                </div>
                                            </div>
                                        </v-flex>
                                        
                                        <v-flex class="xs12 sm5 lg4 order-xs2 order-sm2 text-xs-right picture-presentation">
                                            <v-img :src="require('../assets/home-presentation.png')" max-width="600px" position="top center" class="mt-2"></v-img>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/stores';

export default {
    store,
    computed: {
        ...mapGetters({
            version:  'version',
            isMobile: 'isMobile',
        }),
        titleClass: function()
        {
            return (this.$vuetify.breakpoint.name === 'xs') ? 'display-1' : 'display-3';
        },
        subtitleClass: function()
        {
            return (this.$vuetify.breakpoint.name === 'xs') ? 'headline' : 'display-1';
        },
    },
};
</script>

<style scoped lang="scss">
    ul.right {
        list-style-position: right;
    }

    .picture-presentation {
            background-color: #555;
    }
</style>
